// components/ErrorBoundary.js
import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // Log error to console in development
        console.error('Error caught by boundary:', error, errorInfo);
        this.setState({ error, errorInfo });

        // TODO: Send to error tracking service in production
        // logErrorToService(error, errorInfo);
    }

    handleReset = () => {
        this.setState({ hasError: false, error: null, errorInfo: null });
    };

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f8f5f0',
                    padding: '2rem'
                }}>
                    <div style={{
                        maxWidth: '500px',
                        textAlign: 'center',
                        backgroundColor: 'white',
                        padding: '3rem',
                        borderRadius: '8px',
                        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                    }}>
                        <h1 style={{ color: '#8b7355', marginBottom: '1rem' }}>
                            Oops! Something went wrong
                        </h1>
                        <p style={{ color: '#666', marginBottom: '2rem' }}>
                            We're sorry for the inconvenience. Please try refreshing the page.
                        </p>
                        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
                            <button
                                onClick={() => window.location.reload()}
                                style={{
                                    backgroundColor: '#8b7355',
                                    color: 'white',
                                    padding: '0.75rem 1.5rem',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '1rem'
                                }}
                            >
                                Reload Page
                            </button>
                            <button
                                onClick={this.handleReset}
                                style={{
                                    backgroundColor: 'transparent',
                                    color: '#8b7355',
                                    padding: '0.75rem 1.5rem',
                                    border: '2px solid #8b7355',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '1rem'
                                }}
                            >
                                Try Again
                            </button>
                        </div>
                        {process.env.NODE_ENV === 'development' && this.state.error && (
                            <details style={{ marginTop: '2rem', textAlign: 'left' }}>
                                <summary style={{ cursor: 'pointer', color: '#8b7355' }}>
                                    Error Details
                                </summary>
                                <pre style={{
                                    marginTop: '1rem',
                                    padding: '1rem',
                                    backgroundColor: '#f5f5f5',
                                    borderRadius: '4px',
                                    overflow: 'auto',
                                    fontSize: '0.875rem'
                                }}>
                                    {this.state.error.toString()}
                                    {this.state.errorInfo && this.state.errorInfo.componentStack}
                                </pre>
                            </details>
                        )}
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
